import { render, staticRenderFns } from "./W13V1.vue?vue&type=template&id=441c8a10&scoped=true&"
import script from "./W13V1.vue?vue&type=script&lang=js&"
export * from "./W13V1.vue?vue&type=script&lang=js&"
import style0 from "./W13V1.vue?vue&type=style&index=0&id=441c8a10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441c8a10",
  null
  
)

export default component.exports